import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { fetchWithAuth } from "../api/fetchWithAuth";

const initialFormState = {
  applyTitle: false,
  req_title: "",
  applyDmi: false,
  dmi: true,
  applyOnboard: false,
  onboard: true,
  applyTrackside: false,
  trackside: true,
  applyCategory: false,
  category: ""
};

const categoryOptions = [
  { value: "", label: "none" },
  { value: "informative", label: "informative" },
  { value: "definition", label: "definition" },
  { value: "others", label: "others" }
];

function EraRequirementExtBulkEditModal({ show, onClose, onSaved, selectedCount, selectedIds, apiBase = "/api/era-requirements-ext" }) {
  const [form, setForm] = useState(initialFormState);

  useEffect(() => {
    if (!show) return;
    setForm(initialFormState);
  }, [show]);

  const handleToggle = (event) => {
    const { name, checked } = event.target;
    setForm((current) => ({
      ...current,
      [name]: checked
    }));
  };

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setForm((current) => ({
      ...current,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async () => {
    if (
      !form.applyTitle &&
      !form.applyDmi &&
      !form.applyOnboard &&
      !form.applyTrackside &&
      !form.applyCategory
    ) {
      alert("Select at least one field to update");
      return;
    }

    const res = await fetchWithAuth(`${apiBase}/bulk-update`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ids: selectedIds,
        updates: {
          req_title: form.applyTitle ? form.req_title : undefined,
          dmi: form.applyDmi ? form.dmi : undefined,
          onboard: form.applyOnboard ? form.onboard : undefined,
          trackside: form.applyTrackside ? form.trackside : undefined,
          category: form.applyCategory ? (form.category || null) : undefined
        }
      })
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Bulk update failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Bulk edit {selectedCount} ERA requirements</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Apply Title"
            name="applyTitle"
            checked={form.applyTitle}
            onChange={handleToggle}
          />
          {form.applyTitle && (
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={3}
                name="req_title"
                value={form.req_title}
                onChange={handleChange}
                placeholder="Title"
              />
            </Form.Group>
          )}

          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Apply DMI"
            name="applyDmi"
            checked={form.applyDmi}
            onChange={handleToggle}
          />
          {form.applyDmi && (
            <Form.Check
              className="mb-3 ms-3"
              type="checkbox"
              label="DMI"
              name="dmi"
              checked={form.dmi}
              onChange={handleChange}
            />
          )}

          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Apply Onboard"
            name="applyOnboard"
            checked={form.applyOnboard}
            onChange={handleToggle}
          />
          {form.applyOnboard && (
            <Form.Check
              className="mb-3 ms-3"
              type="checkbox"
              label="Onboard"
              name="onboard"
              checked={form.onboard}
              onChange={handleChange}
            />
          )}

          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Apply Trackside"
            name="applyTrackside"
            checked={form.applyTrackside}
            onChange={handleToggle}
          />
          {form.applyTrackside && (
            <Form.Check
              className="mb-3 ms-3"
              type="checkbox"
              label="Trackside"
              name="trackside"
              checked={form.trackside}
              onChange={handleChange}
            />
          )}

          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Apply Category"
            name="applyCategory"
            checked={form.applyCategory}
            onChange={handleToggle}
          />
          {form.applyCategory && (
            <Form.Group>
              <Form.Select name="category" value={form.category} onChange={handleChange}>
                {categoryOptions.map((option) => (
                  <option key={option.value || "empty"} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EraRequirementExtBulkEditModal;
